import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-video.tsx
/**
* icon.16.video
*
* Keywords: play, media, triangle, right, start, rounded-square, control, frame
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTExLjUgM0ExLjUgMS41IDAgMCAxIDEzIDQuNXY3YTEuNSAxLjUgMCAwIDEtMS4zNDcgMS40OTJMMTEuNSAxM2gtN2wtLjE1My0uMDA4YTEuNSAxLjUgMCAwIDEtMS4zNC0xLjMzOUwzIDExLjV2LTdBMS41IDEuNSAwIDAgMSA0LjUgM3ptLTcgMWEuNS41IDAgMCAwLS41LjV2N2EuNS41IDAgMCAwIC41LjVoN2EuNS41IDAgMCAwIC41LS41di03YS41LjUgMCAwIDAtLjUtLjV6bTIuMDA3IDEuNjNhMSAxIDAgMCAxIDEuMDA4LjAxM2wyLjUgMS41YTEgMSAwIDAgMSAwIDEuNzE0bC0yLjUgMS41QTEuMDAxIDEuMDAxIDAgMCAxIDYgOS41di0zYTEgMSAwIDAgMSAuNTA3LS44N003IDkuNSA5LjUgOCA3IDYuNXoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=19340-18161
*/
const Icon16Video = memo(function Icon16Video(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M11.5 3A1.5 1.5 0 0 1 13 4.5v7a1.5 1.5 0 0 1-1.347 1.492L11.5 13h-7l-.153-.008a1.5 1.5 0 0 1-1.34-1.339L3 11.5v-7A1.5 1.5 0 0 1 4.5 3zm-7 1a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5zm2.007 1.63a1 1 0 0 1 1.008.013l2.5 1.5a1 1 0 0 1 0 1.714l-2.5 1.5A1.001 1.001 0 0 1 6 9.5v-3a1 1 0 0 1 .507-.87M7 9.5 9.5 8 7 6.5z"
		})
	});
});
//#endregion
export { Icon16Video };

//# sourceMappingURL=icon-16-video.js.map